import { PoseGender, PoseGuide } from './model/Challenges.types';

export const MAX_POSES = 5;
export const MAX_POSE_NAME_LENGTH = 24;

export const POSE_PHOTO_WIDTH = 170;
export const POSE_PHOTO_HEIGHT = 270;

export const DEFAULT_POSE_GENDER: PoseGender = 'female';

export const DEFAULT_POSES: Record<PoseGender, PoseGuide[]> = {
  female: [
    {
      name: 'Front',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/female_front.png',
    },
    {
      name: 'Side',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/female_side.png',
    },
    {
      name: 'Back',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/female_back.png',
    },
  ],
  male: [
    {
      name: 'Front',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/male_front.png',
    },
    {
      name: 'Side',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/male_side.png',
    },
    {
      name: 'Back',
      imageUrl:
        'https://d1le80ixkppu39.cloudfront.net/challenges/male_back.png',
    },
  ],
};

export const DEFAULT_PHOTO_INSTRUCTIONS = `- Recommended angle: make sure full body is visible.\n- Please make sure to take photos in good lighting, remember these before/after photos will be used to track your progress from the challenge. You can submit up to 5 photos (but not required).\n- Recommended attire: sports bra/shirtless and shorts.\n- Front: Arms straight out to the sides in a T.\n- Side photo(s): closest arm to camera lifted away from body, to your side.\n- Back photo: arms out in a T.`;
